import React from "react";
import AddressProcess from "../address-process/address-process.component";
import DeliveryProcess from "../delivery-process/delivery-process.component";
import PaymentProcess from "../payment-process/payment-process.component";
import OrderProcess from "../order-process/order-process.component";
import { makeStyles } from "@material-ui/core";
import LoginProcess from "../login-process/login-process.component";
import PersonalInfo from "../personal-info/personal-info.component";

const useStyles = makeStyles({
  orderProcess: {
    "@media (min-width:940px)": {
      display: "none",
    },
  },
});

const CheckoutProcess = ({
  isActiveCustomer,
  setReadyForUserDetails,
  setReadyForLogin,
  setReadyForAddress,
  setReadyForPayment,
  setReadyForDelivery,
  processes,
  onEditAddress,
  onEditPayment,
  onEditDeliveryTime,
  onEditUserDetails,
  onPaymentTokenSelected,
  userData
}) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      {!isActiveCustomer ? (
        <LoginProcess setProcesses={setReadyForLogin} processes={processes} />
      ) : (
        ""
      )}
      {!userData?.activeCustomer?.firstName || !userData?.activeCustomer?.phoneNumber ?
        <PersonalInfo
          processes={processes}
          setProcesses={setReadyForUserDetails}
          onEditUserDetails={onEditUserDetails}
        /> : null}
      <AddressProcess
        setProcesses={setReadyForAddress}
        processes={processes}
        onEditAddress={onEditAddress}
      />
      <PaymentProcess
        setProcesses={setReadyForPayment}
        processes={processes}
        onEditPayment={onEditPayment}
        onPaymentTokenSelected={onPaymentTokenSelected}
      />
      <DeliveryProcess
        setProcesses={setReadyForDelivery}
        processes={processes}
        onEditDeliveryTime={onEditDeliveryTime}
      />
      <div className={classes.orderProcess}>
        <OrderProcess
          setProcesses={setReadyForDelivery}
          processes={processes}
        />
      </div>
    </React.Fragment>
  );
};

export default CheckoutProcess;
